<button
  type="button"
  class="help__labels"
  panelHasPopup="menu"
  [kdsTooltip]="'header.tooltips.help' | translate"
  [disableTooltip]="false"
  [showTooltipOnlyOnDesktop]="true"
  [kdsPanelTrigger]="panel"
  [alwaysDisplayOnTheLeftSide]="true"
  [verticalMargin]="0"
  [closeMenu$]="closeMenu$"
  [attr.aria-label]="'header.tooltips.help' | translate"
  [class.help__labels--active]="isPanelOpened"
  (changePanelVisibility)="isPanelOpened = $event"
>
  <i aria-hidden="true" class="help__icon fa-regular fa-circle-question fa--header-texticon"></i>
</button>

<ng-template #panel>
  <div kdsMenuKeyboardNavigation class="help__items" role="menu" [attr.aria-label]="'header.help' | translate">
    <span class="help__header">{{ 'header.help' | translate }}</span>
    <button type="button" role="menuitem" class="help__item" (click)="openLink(helpLinks.knowledgeBase.url)">
      {{ helpLinks.knowledgeBase.labelTranslateKey | translate }}
    </button>
    <button
      *itcPermission="Permission.VideoTutorialsRead"
      type="button"
      role="menuitem"
      class="help__item"
      (click)="openVideoTutorialsDialog()"
    >
      {{ 'header.video-tutorials' | translate }}
      @if (isDialogLoading()) {
        <kds-spinner />
      }
    </button>
    <button type="button" role="menuitem" class="help__item" (click)="openLink(helpLinks.status.url)">
      {{ helpLinks.status.labelTranslateKey | translate }}
    </button>
    <button type="button" role="menuitem" class="help__item" (click)="openLink(helpLinks.releaseNotes.url)">
      {{ helpLinks.releaseNotes.labelTranslateKey | translate }}
    </button>
    <button type="button" role="menuitem" class="help__item" (click)="openLink(helpLinks.kaseyaInnovations.url)">
      {{ helpLinks.kaseyaInnovations.labelTranslateKey | translate }}
    </button>
    @if (hasAccessToMedalliaIntegrationView()) {
      <button type="button" role="menuitem" class="help__item" (click)="provideFeedback()">
        {{ 'header.provide-feedback' | translate }}
      </button>
    }
    <span class="help__header">{{ 'header.legal' | translate }}</span>
    <button type="button" role="menuitem" class="help__item" (click)="openLink(helpLinks.legalTerms.url)">
      {{ helpLinks.legalTerms.labelTranslateKey | translate }}
    </button>

    @if (hasAccessToLegalTermsArchiveView()) {
      <a role="menuitem" class="help__item" kdsPrefetch [routerLink]="helpLinks.legalTermsArchive.url">
        {{ helpLinks.legalTermsArchive.labelTranslateKey | translate }}
      </a>
    }
  </div>
</ng-template>
